import React from 'react';

import {Field} from 'redux-form';

import {DateField, TextField} from 'components/Fields';
import {required, validDate, validHour} from 'utils/validators';

import './styles.css';

const DateTimeField = ({
  onDateChange,
  onTimeChange,
  dateDisabled,
  timeDisabled,
  dateName,
  timeName
}: any) => (
  <div className="DateTimeField">
    <Field
      name={dateName}
      validate={[required, validDate]}
      component={DateField}
      onDateChange={onDateChange}
      disabled={dateDisabled}
    />
    <Field
      className="hourField"
      name={timeName}
      validate={[required, validHour]}
      component={TextField}
      onChange={onTimeChange}
      disabled={timeDisabled}
    />
  </div>
);

export default DateTimeField;
